var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Há documentos "),_c('b',[_vm._v("obrigatórios")]),_vm._v(" que ainda não foram enviados. ")])}]

export { render, staticRenderFns }